import { render } from "./CoBrandMidnight.vue?vue&type=template&id=3638f61c&scoped=true"
import script from "./CoBrandMidnight.vue?vue&type=script&lang=js"
export * from "./CoBrandMidnight.vue?vue&type=script&lang=js"

import "./CoBrandMidnight.vue?vue&type=style&index=0&id=3638f61c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3638f61c"]])

export default __exports__